
import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useTheme } from "./components/common/ThemeContext";
import Layout from "./components/dashboard/Layout";
import Dashboard from "./pages/dashboard/Dashboard";
import Login from "./pages/auth/Login";
import Page404 from "./pages/auth/Page404";
import PrivateRoute from "./guard/PrivateRoute";
import './assets/css/global.css'
import Department from "./pages/employees/Department";
import FileDashboard from "./pages/fileManager/FileDashboard";
import FileDocuments from "./pages/fileManager/FileDocuments";
import FileMedia from "./pages/fileManager/FileMedia";
import FileImages from "./pages/fileManager/FileImages";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Register from "./pages/auth/Register";
import BlogDashboard from "./pages/blog/BlogDashboard";
import BlogPost from "./pages/blog/BlogPost";
import BlogList from "./pages/blog/BlogList";
import BlogDetail from "./pages/blog/BlogDetail";
import UiTypography from "./pages/uiElement/UiTypography";
import UiTabs from "./pages/uiElement/UiTabs";
import UiButtons from "./pages/uiElement/UiButtons";
import UiIcons from "./pages/uiElement/UiIcons";
import UiColors from "./pages/uiElement/UiColors";
import UiListGroup from "./pages/uiElement/UiListGroup";
import UiModals from "./pages/uiElement/UiModals";
import UiProgressbars from "./pages/uiElement/UiProgressbars";
import LockScreen from "./pages/auth/LockScreen";
import BlankPage from "./pages/pages/BlankPage";
import Profile from "./pages/pages/Profile";
import ImageGallery from "./pages/pages/ImageGallery";
import Timeline from "./pages/pages/Timeline";
import Pricing from "./pages/pages/Pricing";
import Invoice from "./pages/pages/Invoice";
import SearchResult from "./pages/pages/SearchResult";
import Faq from "./pages/pages/Faq";
import BasicTable from "./pages/tables/BasicTable";
import NormalTable from "./pages/tables/NormalTable";
import EditableTable from "./pages/tables/EditableTable";
import TableColor from "./pages/tables/TableColor";
import TableFilter from "./pages/tables/TableFilter";
import ApexChart from "./pages/charts/ApexChart";
import Knob from "./pages/charts/Knob";
import JvectorMap from "./pages/maps/JvectorMap";
import YandexMap from "./pages/maps/YandexMap";
import QuillEditor from "./pages/forms/QuillEditor";
import DragDropUpload from "./pages/forms/DragDropUpload";
import Widget from "./pages/widgets/Widget";
import Documentation from "./pages/documentation/Documentation";
import ChangeLog from "./pages/changeLog/ChangeLog";
import FormValidation from "./pages/forms/FormValidation";
import BasicElements from "./pages/forms/BasicElements";
import DataTable from "./pages/tables/DataTable";
import Holiday from "./pages/holiday/Holiday";
import ProjectDashboard from "./pages/projectDashboard/ProjectDashboard";
import Event from "./pages/event/Event";
import Activity from "./pages/activity/Activity";
import Inbox from "./pages/inbox/Inbox";
import Chat from "./pages/chat/Chat";
import Team from "./pages/team/Team";
import Compose from "./pages/inbox/Compose";
import HrSocial from "./pages/hrSocial/HrSocial";
import Employee from "./pages/employees/Employee";
import Leave from "./pages/employees/Leave";
import Attendance from "./pages/employees/Attendance";
import Payment from "./pages/account/Payment";
import Expense from "./pages/account/Expense";
import AccountInvoice from "./pages/account/Invoice";
import Payslip from "./pages/payroll/Payslip";
import EmployeeSalary from "./pages/payroll/EmployeeSalary";
import ExpenseReport from "./pages/report/ExpenseReport";
import InvoiceReport from "./pages/report/InvoiceReport";
import User from "./pages/user/User";
import AddProject from "./pages/projects/AddProject";
import ProjectList from "./pages/projects/ProjectList";
import ProjectGrid from "./pages/projects/ProjectGrid";
import ProjectDetail from "./pages/projects/ProjectDetail";
import AddClient from "./pages/clients/AddClient";
import ClientList from "./pages/clients/ClientList";
import ClientDetail from "./pages/clients/ClientDetail";
// import TaskBoard from "./pages/taskboard/TaskBoard";
import Ticket from "./pages/ticket/Ticket";
import Company from "./pages/employees/Company";
import Category from "./pages/employees/Category";
import ProfitCenter from "./pages/employees/ProfitCenter";
import Group from "./pages/employees/Group";
import Desigination from "./pages/employees/Desigination";
import EmployeeType from "./pages/employees/EmployeeType";
import Wage from "./pages/employees/Wage";
import WageType from "./pages/employees/WageType";
import Shift from "./pages/employees/Shift";
import PayScale from "./pages/employees/PayScale";
import AllowancesBonus from "./pages/employees/AllowancesBonus";
import ProvidentFund from "./pages/employees/PfSetting";
import JobOpening from "./pages/employees/JobOpening";
import PayRoleType from "./pages/employees/Payrole";
import Gender from "./pages/employees/Gender";
import EmployeeDocs from "./pages/employees/employeeDoc";
import DocType from "./pages/employees/DocType";
import LeaveType from "./pages/employees/LeaveType";
import UserRole from "./pages/employees/UserRole";
import UserRights from "./pages/employees/UserRights";
import { userWiseRight } from "./services/dataService";
import SpecialOccassion from "./pages/employees/SpecialOccassion";
import { Toaster } from "react-hot-toast";
import Employee2 from "./pages/employees/Employee2";
import Duty from "./pages/Transactions/Duty";
import LeaveRequest from "./pages/Transactions/LeaveRequest";
import Musterrole from "./pages/report/Musterrole";
import AttendenceReport from "./pages/report/AttendenceReport";
import ConsoldatedDuty from "./pages/report/ConsoldatedDuty";
import Attendence from "./pages/Transactions/Attendence";
import DetailedAttendence from "./pages/Transactions/DetailedAttendence";
import PunchProcess from "./pages/settings/PunchProcess";
import Loan from "./pages/Transactions/Loan";
import LoanReport from "./pages/report/LoanReport";
import DutyAllocationMuster from "./pages/Transactions/DutyAllocationMuster";
import LevelMaster from "./pages/Transactions/LevelMaster";
import Autherise from "./pages/Transactions/Autherise";
import PayRollReport from "./pages/report/PayRollReport";
import IncrimentReport from "./pages/report/IncrimentReport";
import PunchRecords from "./pages/Transactions/PunchRecords";
import LoanAmountEdit from "./pages/Transactions/LoanAmountEdit";
import LateEmp from "./pages/dashboard/LateEmp";
import ContractEnd from "./pages/dashboard/ContractEnd";
import EmployeeWIesePayslip from "./pages/report/EmployeeWIesePayslip";
import AttendanceCalendar from "./pages/Transactions/AttendanceCalendar";
import TodayLeave from "./pages/dashboard/TodayLeave";
import PendingLeaveToday from "./pages/dashboard/PendingLeaveToday";
import Present from "./pages/dashboard/Present";
import Payrollpending from "./pages/dashboard/Payrollpending";
import AttendancePending from "./pages/dashboard/AttendacnePending";
import NoPunch from "./pages/dashboard/NoPunch";
import WorkingEmp from "./pages/dashboard/WorkingEmp";
import NonWorkingEmp from "./pages/dashboard/NonWorkingEmp";
import Paybill from "./pages/report/Paybill";
import AnnounceMent from "./pages/Transactions/AnnounceMent";
import MobilePunchReports from "./pages/report/MobilePunchReports";
import SharedAnnounceMents from "./pages/Transactions/SharedAnnounceMents";
import ServiceRequestAndPermissions from "./pages/Transactions/ServiceRequestAndpermissions";
import LateDeduction from "./pages/Transactions/LateDeduction";
import DeductionWiseReport from "./pages/report/DeductionWiseReport";
import LoginDetails from "./pages/Transactions/LoginDetails";
import DetailedPfReport from "./pages/report/DetailedPfReport";
import ApprovedNoPunch from "./pages/dashboard/ApprovedNoPunch";
import LeaveTranceActionHistory from "./pages/Transactions/LeaveTranceActionHistory";
import GeneralSettings from "./pages/settings/GeneralSettings";
import { EmployeeLog } from "./pages/employees/EmployeeLog";
import Latelog from "./pages/employees/Latelog";



export default function App() {
  const { selectedOption } = useTheme();

  React.useEffect(() => {
    document.body.setAttribute("lucid-theme", selectedOption);
  }, [selectedOption]);






  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/LoanAmountEdit" element={<LoanAmountEdit />} />
        <Route path="/LateEmp" element={<LateEmp />} />
        <Route path="/ContractEnd" element={<ContractEnd />} />
        <Route path="/TodayLeave" element={<TodayLeave />} />
        <Route path="/PendingLeave" element={<PendingLeaveToday />} />
        <Route path="/Present" element={<Present />} />
        <Route path="/Payrollpending" element={<Payrollpending />} />
        <Route path="/AttendancePending" element={<AttendancePending />} />
        <Route path="/NoPunch" element={<NoPunch />} />
        <Route path="/WorkingEmployees" element={<WorkingEmp />} />
        <Route path="/NonWorkingEmployees" element={<NonWorkingEmp />} />
        <Route path="/SharedAnnounceMents" element={<SharedAnnounceMents />} />
        <Route path="/ApprovedNoPunch" element={<ApprovedNoPunch />} />
                <Route path="/LeaveTranceActionHistory" element={<LeaveTranceActionHistory />} />
















        <Route path="*" element={<Page404 />} />

        {/* Private Routes */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="department" element={<Department />} />
          <Route path="file-dashboard" element={<FileDashboard />} />
          <Route path="file-documents" element={<FileDocuments />} />
          <Route path="file-media" element={<FileMedia />} />
          <Route path="file-images" element={<FileImages />} />
          <Route path="blog-dashboard" element={<BlogDashboard />} />
          <Route path="blog-post" element={<BlogPost />} />
          <Route path="blog-list" element={<BlogList />} />
          <Route path="blog-detail" element={<BlogDetail />} />
          <Route path="ui-typography" element={<UiTypography />} />
          <Route path="ui-tabs" element={<UiTabs />} />
          <Route path="ui-buttons" element={<UiButtons />} />
          <Route path="ui-icons" element={<UiIcons />} />
          <Route path="ui-colors" element={<UiColors />} />
          <Route path="ui-list-group" element={<UiListGroup />} />
          <Route path="ui-modals" element={<UiModals />} />
          <Route path="ui-progressbars" element={<UiProgressbars />} />
          <Route path="page-blank" element={<BlankPage />} />
          <Route path="page-profile" element={<Profile />} />
          <Route path="page-image-gallery" element={<ImageGallery />} />
          <Route path="page-timeline" element={<Timeline />} />
          <Route path="page-pricing" element={<Pricing />} />
          <Route path="page-invoice" element={<Invoice />} />
          <Route path="page-search-result" element={<SearchResult />} />
          <Route path="page-faq" element={<Faq />} />
          <Route path="basic-tabel" element={<BasicTable />} />
          <Route path="normal-tabel" element={<NormalTable />} />
          <Route path="editable-tabel" element={<EditableTable />} />
          <Route path="tabel-color" element={<TableColor />} />
          <Route path="tabel-filter" element={<TableFilter />} />
          <Route path="apex-chart" element={<ApexChart />} />
          <Route path="knob" element={<Knob />} />
          <Route path="jvector-map" element={<JvectorMap />} />
          <Route path="yandex-map" element={<YandexMap />} />
          <Route path="quill-editor" element={<QuillEditor />} />
          <Route path="drag-drop-upload" element={<DragDropUpload />} />
          <Route path="form-validation" element={<FormValidation />} />
          <Route path="basic-elements" element={<BasicElements />} />
          <Route path="widget" element={<Widget />} />
          <Route path="documentation" element={<Documentation />} />
          <Route path="change-log" element={<ChangeLog />} />
          <Route path="data-table" element={<DataTable />} />
          <Route path="holiday" element={<Holiday />} />
          <Route path="project-dashboard" element={<ProjectDashboard />} />
          <Route path="event" element={<Event />} />
          <Route path="activity" element={<Activity />} />
          <Route path="inbox" element={<Inbox />} />
          <Route path="chat" element={<Chat />} />
          <Route path="team" element={<Team />} />
          <Route path="compose" element={<Compose />} />
          <Route path="hr-social" element={<HrSocial />} />
          <Route path="employee" element={<Employee2 />} />
          {/* <Route path="employee" element={<Employee />} /> */}
          <Route path="leave" element={<Leave />} />
          <Route path="attendence" element={<Attendance />} />
          <Route path="department" element={<Department />} />
          <Route path="payment" element={<Payment />} />
          <Route path="expense" element={<Expense />} />
          <Route path="invoice" element={<AccountInvoice />} />
          <Route path="payslip" element={<Payslip />} />
          <Route path="employee-salary" element={<EmployeeSalary />} />
          <Route path="expense-report" element={<ExpenseReport />} />
          <Route path="invoice-report" element={<InvoiceReport />} />
          <Route path="user" element={<User />} />
          <Route path="add-project" element={<AddProject />} />
          <Route path="project-list" element={<ProjectList />} />
          <Route path="project-grid" element={<ProjectGrid />} />
          <Route path="project-detail" element={<ProjectDetail />} />
          <Route path="add-client" element={<AddClient />} />
          <Route path="client-list" element={<ClientList />} />
          <Route path="client-detail" element={<ClientDetail />} />
          {/* <Route path="taskboard" element={<TaskBoard />} /> */}
          {/* adding more masters */}
          <Route path="company" element={<Company />} />
          <Route path="category" element={<Category />} />
          <Route path="profit-center" element={<ProfitCenter />} />
          <Route path="group" element={<Group />} />
          <Route path="designation" element={<Desigination />} />
          <Route path="employee-type" element={<EmployeeType />} />
          <Route path="wage-components" element={<Wage />} />
          <Route path="wage-type" element={<WageType />} />
          <Route path="shift" element={<Shift />} />
          <Route path="pay-scale" element={<PayScale />} />
          <Route path="allowance-bonus" element={<AllowancesBonus />} />
          <Route path="pf-setting" element={<ProvidentFund />} />
          <Route path="job-opening" element={<JobOpening />} />
          <Route path="payrole-type" element={<PayRoleType />} />
          <Route path="user-rights" element={<UserRights />} />
          <Route path="user-role" element={<UserRole />} />
          <Route path="specialoccassions" element={<SpecialOccassion />} />
          <Route path="levelmaster" element={<LevelMaster />} />
          <Route path="punchrecords" element={<PunchRecords />} />
          <Route path="duty" element={<Duty />} />
          <Route path="autherise" element={<Autherise />} />
          <Route path="dutymuster" element={<DutyAllocationMuster />} />
          <Route path="Attendance" element={<Attendence />} />
          <Route path="leaverequest" element={<LeaveRequest />} />
          <Route path="musterroll" element={<Musterrole />} />
          <Route path="Paybill-Register" element={<Paybill />} />
          <Route path="Announcement" element={<AnnounceMent />} />
          <Route path="mobilePunchreport" element={<MobilePunchReports />} />
          <Route path="mobilePunchreport" element={<MobilePunchReports />} />
          <Route path="ServiceRequest-permission" element={<ServiceRequestAndPermissions />} />
          <Route path="LateDeduction" element={<LateDeduction />} /> 
          <Route path="DeductionReport" element={<DeductionWiseReport />} />
          <Route path="LoginDetails" element={<LoginDetails />} />
          <Route path="/pfreport" element={<DetailedPfReport />} />
          <Route path="/employeelog" element={<EmployeeLog />} />
          <Route path="/latelog" element={<Latelog />} />
            <Route path="/generalSettings"element={<GeneralSettings/>}/>








          <Route path="employeewisepayslip" element={<EmployeeWIesePayslip />} />
          <Route path="attendancereport" element={<AttendenceReport />} />
          <Route path="loanreport" element={<LoanReport />} />
          <Route path="consolidatedduty" element={<ConsoldatedDuty />} />
          <Route path="DetailedAttendance" element={<DetailedAttendence />} />
          <Route path="punchprocess" element={<PunchProcess />} />
          <Route path="loan" element={<Loan />} />
          <Route path="Payrollreport" element={<PayRollReport />} />
          <Route path="IncrimentReports" element={<IncrimentReport />} />
          <Route path="attendancecalendar" element={<AttendanceCalendar />} />
          {/* Add more private child routes here */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
